module.exports = __webpack_public_path__ + "pc-top-assets/img/search.190d3465.png";